import React from 'react';
import styled from 'styled-components';
import {
  getInviteTypeMeta,
  getRequestStatusMeta,
  getRoleLabel,
} from 'components/Tables/NotificationTable/notificationTableConstants';
import { useDemoMask } from 'hooks/useDemoMask';

export const LandlordDetailsCard = ({ detail }) => {
  const { isDemo, mask } = useDemoMask();
  if (!detail) return null;

  const inviteMeta = getInviteTypeMeta(detail.request_type);
  const statusMeta = getRequestStatusMeta(detail.request_status);

  return (
    <LandlordDetailsCardContainer>
      <MainContainer>
        <DetailDiv>
          <p>Request Type</p>
          <p>{inviteMeta?.text || detail.request_type}</p>
        </DetailDiv>
        <DetailDiv>
          <p>Status</p>
          <p>{statusMeta.text}</p>
        </DetailDiv>
        <DetailDiv>
          <p>From Email</p>
          <p>{mask('email', detail.requestor_email)}</p>
        </DetailDiv>
        <DetailDiv>
          <p>From Role</p>
          <p>{getRoleLabel(detail.requestor_role)}</p>
        </DetailDiv>
        <DetailDiv>
          <p>To Email</p>
          <p>{mask('email', detail.accepter_email)}</p>
        </DetailDiv>
        <DetailDiv>
          <p>To Role</p>
          <p>{getRoleLabel(detail.accepter_role)}</p>
        </DetailDiv>
        {detail.email_text ? (
          <DetailDivWide>
            <p>Message</p>
            {isDemo ? (
              <p>{mask('invoice-description', detail.email_text)}</p>
            ) : (
              <MessageHtml dangerouslySetInnerHTML={{ __html: detail.email_text }} />
            )}
          </DetailDivWide>
        ) : null}
        <DetailDiv>
          <p>Updated Date</p>
          <p>
            {detail.updatedAt
              ? new Date(detail.updatedAt).toISOString().slice(0, 10)
              : detail.createdAt}
          </p>
        </DetailDiv>
        <DetailDiv>
          <p>Property Count</p>
          <p>{detail.property?.length ?? 0}</p>
        </DetailDiv>
        {detail.decline_reason ? (
          <DetailDiv>
            <p>Decline Reason</p>
            <p>{detail.decline_reason}</p>
          </DetailDiv>
        ) : null}
      </MainContainer>
    </LandlordDetailsCardContainer>
  );
};

const LandlordDetailsCardContainer = styled.div`
  border-radius: 12px;
  background-color: #f8f4f97a;
  padding: 24px;
  border: 1px solid #f8f4f9;
`;

const MainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  & > div:not(:last-child) {
    /* border-right: 2px solid #E8D6EB; */
    margin-right: 20px;
  }
  & > div:first-child {
    /* padding-left: 0; */
  }
`;

const DetailDivWide = styled.div`
  flex: 1 1 100%;
  max-width: 100%;

  p {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    font-weight: bold;
  }
  & > p:nth-child(1) {
    color: #a39aa9;
    margin-bottom: 8px;
  }
`;

const MessageHtml = styled.div`
  font-size: 13px;
  color: #2e0f40;
  line-height: 1.5;

  p {
    margin: 0 0 8px;
  }
`;

const DetailDiv = styled.div`
  /* padding: 0 10px; */
  p {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    font-weight: bold;
  }
  & > p:nth-child(1) {
    color: #a39aa9;
    margin-bottom: 8px;
  }
  & > p:nth-child(2) {
    color: #2e0f40;
  }
`;
